import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';
import dayjs from 'dayjs';


export let chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgba(54, 162, 235, 0.7)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
    good: '#C1C1C1',
    info: '#154889',
    none: '#154889',
    low: 'rgba(247, 186, 11, 0.7)',
    medium: 'rgba(212, 101, 47, 0.7)',
    high: 'rgba(160, 33, 40, 0.7)',
    critical: 'rgba(144, 70, 132, 0.7)'
};


export function randomScalingFactor() {
    return Math.floor(Math.random() * 101);
};

export function dateText(date) {
    let readLocale = getStore(locale);
    locale.set(readLocale);

    function calcDays(date1, date2){
        let day1 = new Date(date1.toISOString().split("T")[0]);
        let day2 = new Date(date2.toISOString().split("T")[0]);
        const timeDiff = Math.abs(day2.getTime() - day1.getTime());
        const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        return daysDiff + "d";
    }
    //returns a shorter version of the string returned by dayjsjs fromNow (used by the template)
    //https://dayjsjs.com/docs/#/displaying/fromnow/ ---> see range and sample output

    let seconds = dayjs().diff(dayjs(date), 'seconds');
    //show seconds
    if(seconds < 45) { return seconds + "s"; }
    //between 45s and 1.5m show 1m
    if(seconds >= 45 && seconds < 90) { return "1m"; }
    if(seconds >= 90){
        let minutes = dayjs().diff(dayjs(date), 'minutes');
        //show seconds as minutes
        if(minutes < 45) {return Math.round(seconds/60) + "m";}
        //between 45m and 1.5h show 1h
        if(minutes >= 45 && minutes < 90) { return "1h"; }

        if(minutes >= 90) {
            let hours = dayjs().diff(dayjs(date), 'hours');
            //show minutes as hours
            if(hours < 24) {return Math.floor(minutes/60) + "h";}

            if(hours >= 24) {
                let days = dayjs().diff(dayjs(date), 'days');
                //show hours as days
                if(days < 30) {return calcDays(new Date(date), new Date())}
                //between 25d and 1.5M show 1M
                if(days >= 30 && days <= 45) { return "1M"; }

                if(days > 45 && days <= 320) {
                    //show days as months
                    return Math.round(days/30) + "M";
                }
                //between 321d and 457d show 1A (0.87 to 1.5 year)
                if(days > 320 && days <= 547) { return readLocale == "es" ? "1A" : "1Y"; }

                if (days > 547){
                    //show days as years (1.5year or more)
                    return Math.round(days/365) + (readLocale == "es" ? "A" : "Y");
                }
            }
        }

    }
}

// javascript implementation to sort
// the array of the IP Address
// Custom Comparator to sort the
// Array in the increasing order
export function ipAdressesCustomComparator(a, b){
    let octetsA;
    let octetsB;
    if(typeof a == 'string' && typeof b == 'string'){
        // Breaking into the octets
        octetsA = a.split(".");
        octetsB = b.split(".");
    }
    else {
        octetsA = a.name.split(".");
        octetsB = b.name.split(".");
    }

    for(let [index, octect] of octetsA.entries()){
        octetsA[index] = parseInt(octetsA[index]);
    }

    for(let [index, octect] of octetsB.entries()){
        octetsB[index] = parseInt(octetsB[index]);
    }

    // Condition if the IP Address
    // is same then return 0
    if(octetsA == octetsB)
        return 0;
    else if(octetsA[0] > octetsB[0])
        return 1;
    else if(octetsA[0] < octetsB[0])
        return -1;
    else if(octetsA[1] > octetsB[1])
        return 1;
    else if(octetsA[1] < octetsB[1])
        return -1;
    else if(octetsA[2] > octetsB[2])
        return 1;
    else if(octetsA[2] < octetsB[2])
        return -1;
    else if(octetsA[3] > octetsB[3])
        return 1;
    else if(octetsA[3] < octetsB[3])
        return -1;
}

export function locationCustomComparator(a, b){
    let addressA = a.split("://");
    let addressB = b.split("://");
    let octetsA;
    let octetsB;
    if(typeof a == 'string' && typeof b == 'string'){
        // Breaking into the octets
        octetsA = addressA[1].split(".");
        octetsB = addressB[1].split(".");
    }

    for(let [index, octect] of octetsA.entries()){
        octetsA[index] = parseInt(octetsA[index]);
    }

    for(let [index, octect] of octetsB.entries()){
        octetsB[index] = parseInt(octetsB[index]);
    }

    // Condition if the IP Address
    // is same then return 0
    if(octetsA == octetsB)
        return 0;
    else if(octetsA[0] > octetsB[0])
        return 1;
    else if(octetsA[0] < octetsB[0])
        return -1;
    else if(octetsA[1] > octetsB[1])
        return 1;
    else if(octetsA[1] < octetsB[1])
        return -1;
    else if(octetsA[2] > octetsB[2])
        return 1;
    else if(octetsA[2] < octetsB[2])
        return -1;
    else if(octetsA[3] > octetsB[3])
        return 1;
    else if(octetsA[3] < octetsB[3])
        return -1;
}

// Function to sort the IP Addresses
export function sortIPAddress(arr){
    // Sort the Array using
    // Custom Comparator
    return arr.sort(ipAdressesCustomComparator);
}

export const addressPattern = /^(?:(?:[1-9]?[0-9]|1[0-9][0-9]|2(?:[0-4][0-9]|5[0-5]))\.){3}(?:[1-9]?[0-9]|1[0-9][0-9]|2(?:[0-4][0-9]|5[0-5]))(?:\/(?:[12]?[0-9]|3[0-2]))?$/

export function findingsAssetNameCustomComparator(a, b){

    if(a.vulnerability && b.vulnerability && a.vulnerability.localeCompare(b.vulnerability) === 0){

        if(!addressPattern.test(a.asset.name) && !addressPattern.test(b.asset.name)) return a.asset.name.localeCompare(b.asset.name);
        if(addressPattern.test(a.asset.name) && !addressPattern.test(b.asset.name))  return -1;
        if(!addressPattern.test(a.asset.name) && addressPattern.test(b.asset.name))  return 1;
        let octetsA;
        let octetsB;

        octetsA = a.asset.name.split(".");
        octetsB = b.asset.name.split(".");

        for(let [index, octect] of octetsA.entries()){
            octetsA[index] = parseInt(octetsA[index]);
        }

        for(let [index, octect] of octetsB.entries()){
            octetsB[index] = parseInt(octetsB[index]);
        }
        // Condition if the IP Address
        // is same then return 0
        if(octetsA == octetsB)
            return 0;
        else if(octetsA[0] > octetsB[0])
            return 1;
        else if(octetsA[0] < octetsB[0])
            return -1;
        else if(octetsA[1] > octetsB[1])
            return 1;
        else if(octetsA[1] < octetsB[1])
            return -1;
        else if(octetsA[2] > octetsB[2])
            return 1;
        else if(octetsA[2] < octetsB[2])
            return -1;
        else if(octetsA[3] > octetsB[3])
            return 1;
        else if(octetsA[3] < octetsB[3])
            return -1;
    }
    else {
        return a.vulnerability.localeCompare(b.vulnerability);
    }
}

export function sortFindingsAssetName(arr){
    // Sort the Array using
    // Custom Comparator
    return arr.sort(findingsAssetNameCustomComparator);
}


export function allAssetNameCustomComparator(a, b){
    if(!addressPattern.test(a.name) && !addressPattern.test(b.name)) return a.name.localeCompare(b.name);
    if(addressPattern.test(a.name) && !addressPattern.test(b.name))  return -1;
    if(!addressPattern.test(a.name) && addressPattern.test(b.name))  return 1;
    let octetsA;
    let octetsB;

    octetsA = a.name.split(".");
    octetsB = b.name.split(".");

    for(let [index, octect] of octetsA.entries()){
        octetsA[index] = parseInt(octetsA[index]);
    }

    for(let [index, octect] of octetsB.entries()){
        octetsB[index] = parseInt(octetsB[index]);
    }
    // Condition if the IP Address
    // is same then return 0
    if(octetsA == octetsB)
        return 0;
    else if(octetsA[0] > octetsB[0])
        return 1;
    else if(octetsA[0] < octetsB[0])
        return -1;
    else if(octetsA[1] > octetsB[1])
        return 1;
    else if(octetsA[1] < octetsB[1])
        return -1;
    else if(octetsA[2] > octetsB[2])
        return 1;
    else if(octetsA[2] < octetsB[2])
        return -1;
    else if(octetsA[3] > octetsB[3])
        return 1;
    else if(octetsA[3] < octetsB[3])
        return -1;

}

export function sortAllAssets(arr){
    // Sort the Array using
    // Custom Comparator
    return arr.sort(allAssetNameCustomComparator);
}

export function removeTags(str) {
    if (!str || str === ''){
        return null;
    }
    else{
        // Regular expression to identify HTML tags in
        // the input string. Replacing the identified
        // HTML tag with a null string.
        str = str.toString();
    }
    return str.replace(/(<([^>]+)>)/ig, '');
}

export function isJson (str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function normalizeString(str){
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

export const truncateString = (str, maxLength) => {
    if (str.length > maxLength) {
        return str.slice(0, maxLength - 3) + "...";
    }
    return str;
};

export const replacePortUrl = (str) => {
    return str.replace("tcp/", "tcp%2F")
}

export const sortVulnerabilitiesByTitle = (vuls) =>{
    return vuls.sort((a, b) => {
        if (!a.title) a.title = a.id;
        if (!b.title) b.title = b.id;
        if (!a.title_es) a.title_es = a.title;
        if (!b.title_es) b.title_es = b.title;
        return a.title_es.localeCompare(b.title_es);
    });
}